export const AMAZON_URL =
  "https://www.amazon.com/dp/B09JDX1YDN?ref_=ppx_hzod_title_dt_b_fed_asin_title_1_0";

export const COVER_URL = "https://m.media-amazon.com/images/I/61Djx3c+APL.jpg";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
